/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CouponCodeSummaryViewModel } from "../types/CouponCodeSummaryViewModel.ts";

export const couponCodeSummaryViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID do cupom.")),
  description: z.string().describe("Descrição do cupom.").nullish(),
  automatic: z.optional(
    z.boolean().describe("Indica se o cupom é automático ou manual."),
  ),
  quantity: z
    .number()
    .int()
    .describe("Quantidade total de utilizações permitidas. Opcional.")
    .nullish(),
  used: z.optional(
    z
      .number()
      .int()
      .describe("Quantidade de utilizações já aplicadas do cupom."),
  ),
}) as unknown as ToZod<CouponCodeSummaryViewModel>;
